<template>
  <div>
    <div
      class="logistics-head"
      v-if="info.state > 0"
    >{{info.shipperName}}包裹 {{info.logisticCode}}</div>
    <div
      class="content"
      v-if="info.state > 0"
    >
      <div
        class="common"
        v-for="(item,index) in info.traces"
        :key="index"
      >
        <div
          class="common-left"
          :class="{'active':index == 0}"
        >
          <p class="date">{{item.date}}</p>
          <p class="time">{{item.time}}</p>
        </div>
        <div
          class="common-right"
          :class="{'active':index == 0}"
        >
          <div class="dot"></div>
          <div>
            <p
              class="state"
              v-if="index == 0"
            >{{info.state == 1? "已揽件" : info.state == 2? "运输中" : info.state == 3? "已签收" : info.state == 4? "问题件" : info.state == 0? "暂无物流轨迹" : ""}}</p>
            <p class="text">{{item.acceptStation}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="notHave"
      :class="{'cover':!$store.getters.ambientType}"
      v-if="info.state == 0"
    >
      <i class="iconfont icon-wuliu"></i>
      <p>物流获取信息失败</p>
    </div>
  </div>
</template>

<script>
import { getOrderExpress } from "@/api/join";
export default {
  data() {
    return {
      info: {
        state: -1
      },
    };
  },
  mounted() {
    getOrderExpress({
      orderId: this.$route.query.orderId,
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        for (let i = 0; i < res.content.traces.length; i++) {
          if (res.content.traces[i].acceptTime) {
            let date = res.content.traces[i].acceptTime.split(" ")[0];
            let time = res.content.traces[i].acceptTime.split(" ")[1];
            res.content.traces[i].date =
              date.split("-")[1] + "-" + date.split("-")[2];
            res.content.traces[i].time =
              time.split(":")[0] + ":" + time.split(":")[1];
          }
        }
        this.info = res.content;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.logistics-head {
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  font-size: 15px;
}
.content {
  margin: 10px 15px 0;
  .common {
    position: relative;
    .common-left {
      position: absolute;
      top: 0;
      left: 0;
      text-align: right;
      color: #999999;
      .date {
        font-size: 14px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        color: #999999;
      }
    }
    .common-right {
      position: relative;
      display: flex;
      color: #999999;
      padding-bottom: 26px;
      margin-left: 56px;
      &::after {
        content: "";
        position: absolute;
        pointer-events: none;
        background-color: #d9d9d9;
        width: 1px;
        top: 6px;
        left: 3.5px;
        bottom: -6px;
        z-index: 1;
      }
      .dot {
        flex: 0 0 8px;
        height: 8px;
        margin-top: 6px;
        margin-right: 11px;
        background-color: #d9d9d9;
        border-radius: 50%;
        z-index: 100;
      }
      .state {
        font-size: 16px;
        line-height: 22px;
      }
      .text {
        font-size: 14px;
      }
    }
    .active {
      color: #1d1d1d;
      .dot {
        background-color: #83ce35;
      }
    }
  }
  .common:last-child {
    .common-right {
      &::after {
        opacity: 0;
      }
    }
  }
}
.notHave {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background-color: #f5f5f5;
  i {
    display: block;
    margin-top: 178px;
    font-size: 107px;
    color: #d5d5d7;
  }
  p {
    font-size: 15px;
    color: #a3a2a2;
    margin-top: 32px;
  }
}
.cover {
  top: 0;
}
</style>